<template>
  <div class="userinvoice-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入手机号查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" ref="userList" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!--修改地址-->
    <Modal
      v-model="showEditStatus"
      title="修改"
      @on-ok="updateAddress('addressValidate')"
      :loading="loading"
    >
      <Form
        :model="addressInfo"
        ref="addressValidate"
        :rules="addressValidate"
        action="javascript:void(0)"
      >
        <FormItem>
          <Select placeholder="发票抬头" v-model="addressInfo.title" clearable>
            <Option :value="0">个人</Option>
            <Option :value="1">企业</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select placeholder="发票类型" v-model="addressInfo.invoice_type" clearable>
            <Option :value="0">普票</Option>
            <Option :value="1">专票</Option>
          </Select>
        </FormItem>
        <FormItem label="单位名称">
          <Input v-model="addressInfo.company" placeholder="输入单位名称..."></Input>
        </FormItem>
        <FormItem label="税号">
          <Input v-model="addressInfo.shuihao" placeholder="输入税号..."></Input>
        </FormItem>
        <FormItem label="注册地址">
          <Input v-model="addressInfo.address"></Input>
        </FormItem>
        <FormItem label="注册电话">
          <Input v-model="addressInfo.phone"></Input>
        </FormItem>
        <FormItem label="开户行">
          <Input v-model="addressInfo.bank"></Input>
        </FormItem>
        <FormItem label="银行账号">
          <Input v-model="addressInfo.account"></Input>
        </FormItem>
        <!-- <FormItem>
          <Select placeholder="发票内容" v-model="addressInfo.content" clearable>
            <Option :value="0">商品明细</Option>
            <Option :value="1">商品类别</Option>
          </Select>
        </FormItem>-->
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "userinvoice-list",
  data() {
    return {
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      addressValidate: {
        // person: [{ required: true, message: "姓名必须填写", trigger: "blur" }],
        // phone: [{ required: true, message: "手机号必须填写", trigger: "blur" }],
        // address: [{ required: true, message: "地址必须填写", trigger: "blur" }]
      },
      formItem: {},
      address_id: 0,
      dataloading: false,
      loading: false,
      showEditStatus: false,
      list: [
        {
          title: "ID",
          width: 100,
          key: "id"
        },
        // {
        //   title: "姓名",
        //   width: 200,
        //   key: "username"
        // },
        {
          title: "公司名称",
          width: 150,
          key: "company"
        },
        {
          title: "税号",
          width: 150,
          key: "shuihao"
        },
        {
          title: "公司地址",
          width: 150,
          key: "address"
        },
        {
          title: "公司电话",
          width: 200,
          key: "phone"
        },
        {
          title: "开户行",
          width: 200,
          key: "bank"
        },
        {
          title: "银行账户",
          width: 150,
          key: "account"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEdit(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      addressInfo: {}
    };
  },
  created: function() {
    this.useruuid = this.$route.params.uuid;
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        uuid: this.useruuid
      };
      this.$api.userinvoice.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    showEdit(id) {
      this.address_id = id;
      this.$api.userinvoice.detail({ invoice_id: id }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.addressInfo = res.result;
        }
      });
      this.showEditStatus = true;
    },
    updateAddress() {
      this.addressInfo.invoice_id = this.address_id;
      this.$api.userinvoice.edit(this.addressInfo).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.showEditStatus = false;
          this.getTableList();
        } else {
          this.showEditStatus = true;
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },

    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.userinvoice.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.userinvoice.remove({ invoice_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>